export default class CategoryActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_CATEGORYEMPLOYEE='GET_HELPER_CATEGORYEMPLOYEE';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  static submit(){
    return {
      type: CategoryActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type: CategoryActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type: CategoryActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type: CategoryActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type: CategoryActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type: CategoryActions.SHOW_DATA,
      payload: data
    };
  }
  static resetList() {
    return {
      type: CategoryActions.RESET_LIST
    };
  }
  static error(error){
    return {
      type: CategoryActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type: CategoryActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type: CategoryActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type: CategoryActions.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type: CategoryActions.GET_HELPER_CATEGORYEMPLOYEE,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type: CategoryActions.ERROR_SERVER,
      payload: error
    };
  }
}